import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=f42729ce&"
import script from "./checkbox.js?vue&type=script&lang=js&"
export * from "./checkbox.js?vue&type=script&lang=js&"
import style0 from "./checkbox.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports